import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const existingItem = state.items.find(item => item._id === action.payload._id);

      if (existingItem) {
        existingItem.quantity = Math.max(Number(existingItem.quantity || 0) + 1, 1); // Ensure valid quantity increment
      } else {
        state.items.push({ ...action.payload, quantity: 1 }); // Set default quantity
      }
    },
    addComplimentaryItem: (state, action) => {
      const complimentaryProduct = {
        ...action.payload,
        price: 0, // Set price to 0 for complimentary products
        quantity: 1,
        isComplimentary: true
      };
      
      const existingItem = state.items.find(item => item._id === action.payload._id);
      if (!existingItem) {
        state.items.push(complimentaryProduct);
      }
    },
    removeItem: (state, action) => {
      state.items = state.items.filter(item => item._id !== action.payload);
    },
    increaseQuantity: (state, action) => {
      const item = state.items.find(item => item._id === action.payload);
      if (item) {
        item.quantity = Math.max(Number(item.quantity || 0) + 1, 1); // Ensure valid increment
      }
    },
    decreaseQuantity: (state, action) => {
      const item = state.items.find(item => item._id === action.payload);
      if (item) {
        if (Number(item.quantity) > 1) {
          item.quantity = Math.max(Number(item.quantity || 0) - 1, 1); // Ensure valid decrement
        } else {
          state.items = state.items.filter(cartItem => cartItem._id !== action.payload);
        }
      }
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, addComplimentaryItem, removeItem, increaseQuantity, decreaseQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
